import * as React from 'react';
import { observer } from 'mobx-react';
import { Alert } from '@payscale/design';
import { formatDate, dateTextFormat } from 'utils/dateUtils';
import { Configuration } from 'nomst/Stores/Configuration/configuration';
import './cycleClosedAlert.scss';

interface CycleClosedAlertProps {
    hasHrOrSupportRole: boolean;
    configuration: Configuration;
}

export class CycleClosedAlert extends React.Component<CycleClosedAlertProps> {
    render(): React.ReactNode {
        const { configuration, hasHrOrSupportRole } = this.props;
        if (!configuration.isClosed || hasHrOrSupportRole) {
            return null;
        }

        return (
            <Alert
                className="nomst-cycle-closed-alert"
                message={this.renderCycleClosedMessage()}
                level="success"
                close={false}
            />
        );
    }

    renderCycleClosedMessage(): React.ReactNode {
        return (
            <div className="cycle-closed-alert__message">
                <strong>{this.getCycleClosedAlertTitle()}</strong>
                <p className="cycle-closed-alert__description">
                    Your pay decisions are now locked from further review.
                </p>
            </div>
        );
    }

    getCycleClosedAlertTitle(): string {
        const { configuration } = this.props;
        const cycleClosedDate = configuration?.closedDate
            ? ` on ${formatDate(configuration.closedDate, dateTextFormat)}`
            : '';

        return `This cycle was closed${cycleClosedDate}.`;
    }
}

export default observer(CycleClosedAlert);